import { APICore } from './apiCore';

const api = new APICore();

export interface CategoryListParams {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: 'asc' | 'desc';
    search?: string;
    isActive?: boolean;
}

function getCategories(params?: CategoryListParams) {
    return api.get('/categories', params);
}

function getCategoryTree() {
    return api.get('/categories/tree', null);
}

function getCategoryById(id: number) {
    return api.get(`/categories/${id}`, null);
}

function createCategory(data: {
    name: string;
    slug?: string;
    parentId?: number | null;
    imageUrl?: string | null;
    displayOrder?: number;
    isActive?: boolean;
    createdBy?: string;
    updatedBy?: string;
}) {
    return api.create('/categories', data);
}

function updateCategory(
    id: number,
    data: {
        name?: string;
        slug?: string;
        parentId?: number | null;
        imageUrl?: string | null;
        displayOrder?: number;
        isActive?: boolean;
        updatedBy?: string;
    }
) {
    return api.updatePatch(`/categories/${id}`, data);
}

function getCategoryProducts(
    id: number,
    params?: {
        page?: number;
        limit?: number;
        sortBy?: string;
        sortType?: 'asc' | 'desc';
        includeDescendants?: boolean;
    }
) {
    return api.get(`/categories/${id}/products`, { customerId: 0, ...params });
}

function deleteCategory(id: number) {
    return api.delete(`/categories/${id}`);
}

export { getCategories, getCategoryTree, getCategoryById, getCategoryProducts, createCategory, updateCategory, deleteCategory };
